import { clearUserTrackingSession } from './thirdPartyTracking';

const LOGOUT_EVENT_TIMEOUT = 1000;

export const pushLogoutEvent = onComplete => {
  clearUserTrackingSession();
  let completed = false;
  let timeoutId;
  const complete = () => {
    if (completed) return;
    completed = true;
    window.clearTimeout(timeoutId);
    onComplete();
  };

  window.dataLayer = window.dataLayer || [];
  timeoutId = window.setTimeout(complete, LOGOUT_EVENT_TIMEOUT);
  window.dataLayer.push({
    event: 'LOG_OUT',
    eventCallback: complete,
    eventTimeout: LOGOUT_EVENT_TIMEOUT,
  });
};
